jQuery(document).ready(function($) {
    
    $('#login h1 > a').hide();
    var $loginForm = $('#login form');
    //$('<h2 class="gk-login-title">'+gk_login.siteName+'</h2>').prependTo($loginForm);
    $('<a href="/" aria-label="Gå till startsidan på webbplatsen"><img src="/wp-content/themes/gavle/assets/img/Gavlekommun-logotyp.png" class="logo"/></a>').prependTo($loginForm);

    var facebookAnchor = $('#login .wp-social-login-provider-facebook');
    var facebookImg = $('#login .wp-social-login-provider-facebook img');
    var googleAnchor = $('#login .wp-social-login-provider-google');
    var googleImg = $('#login .wp-social-login-provider-google img');

    // Changes to facebook.
    facebookImg.attr('src', '/wp-content/themes/gavle/assets/img/facebook.png');
    facebookAnchor.append('<span>Facebook</span>');

    // Changes to Google.
    googleImg.attr('src', '/wp-content/themes/gavle/assets/img/google.png');
    googleAnchor.append('<span>Google</span>');

    // Medarbetare
    $('<a href="' + gk_login.siteUrl + '/wp-login-ad.php?redirect_to=' + encodeURIComponent(gk_login_requestQueryString('redirect_to')) +'"><img src="/wp-content/themes/gavle/assets/img/gavle.png"><span>Medarbetare</span></a>').appendTo($('.wp-social-login-provider-list'));

    // Get querystring value by name
    function gk_login_requestQueryString(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return '';
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
});